<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import ApiType from "@/components/modals/api-type.vue";
import BackLogModal from "@/components/modals/backlogs.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import ResourceUpdate from "@/router/views/office/office-widgets/planning-resource-item.vue";
import OpcrLogs from "@/router/views/office/office-widgets/opcr-logs.vue";
import CartItems from "@/router/views/office/office-widgets/cart-items.vue";
import RequestItems from "@/router/views/office/office-widgets/request-items.vue";
import OPCRView from "@/components/widgets/opcr-view.vue";
import ItemsView from "@/components/widgets/items-view.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";

export default {
    page: {
        title: "Planning OPCR/WFP",
    },
    components: {
        Layout,
        PageHeader,
        ApiType,
        BackLogModal,
        PrintOptions,
        ResourceUpdate,
        OpcrLogs,
        CartItems,
        RequestItems,
        OPCRView,
        AttachmentModal,
        ItemsView
    },
    data() {
        return {
            title: `My Planning ${this.$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`,
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: `My Planning ${this.$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`,
                    active: true,
                },
            ],
            targetData: [],
            modalTitle: "",
            form: {
                id: 0,
                name: "",
                description: "",
                schedule: "",
                expectedOutput: "",
                planningTargetId: 0,
                isBigProject: false,
                apiTypeId: 0,
                addressingClimateChange: false,
                climateAddress: 'Adaptation'
            },
            indexSelected: -1,
            tableBusy: false,
            apiType: "",
            cycle: "",
            itemList: [],
            perPageItem: 1,
            currentPageItem: 1,
            loadItems: false,
            selectedItem: 0,
            selectedApi: {},
            selectedApiId: 0,
            budgetItem: "",
            ppmpIndex: -1,
            apiName: "",
            selectedPPMPStatus: "",

            // resource items
            itemLoading: false,
            resourceItems: [],
            previousWork: {},
            uploadOptions: {
                type: "API",
                placement: "lefttop",
                folder: "Planning",
            },
            selectedTransfer: {},
            inflationRate: null,
            selectedTransferBudget: {},
            moveApi: null,
            frontPage: true,
            opcrs: [],
            opcr: {
                id: null,
                title: null,
                deliveryUnitId: null,
                cycle: null,
                isSupplemental: null,
            },
            loadOpcrs: false,
            selectedOPCR: null,
            selectedTarget: null,
            selectAllAPI: true,
            startTransferAPI: false,
            startSelection: false,
            directionElement: null,
            startTranferApiToOPCR: false,
            selectedFS: "",
            selectedBudget: "",
            selectedBudgetId: 0,
            selectedApiActions: '',
            carts: [],
            approved: [],
            approveLoading: false,
            departmentOPCRs: [],
            loadDepartmentOPCRs: false,
            selectedAllTarget: null,
            climateAddreses: ['Adaptation', 'Mitigation']
        };
    },
    validations: {
        form: {
            name: { required },
        },
        apiType: { required },
        previousWork: {
            name: { required },
        },
        opcr: {
            title: { required },
        }
    },
    async mounted() {
        this.selectAllAPI = false;
        await this.changeCycle(this.$store.state.data.cycle, true);
        this.getCartItems(this.$store.state.data.selectedDU.id);
    },
    methods: {
        async getCartItems(id) {
            await this.$store
                .dispatch("deliveryunititemcart/GetDeliveryUnitItemCartByDU", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.item.itemName} ${item.item.description}`;
                    })
                    this.carts = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        totalResourceItemAmt() {
            var data = this.resourceItems;
            var sum = 0;
            data.forEach((item) => {
                sum += parseFloat(item.totalWithInflation);
            });
            return this.formatCurrency(sum);
        },
        addApi(target) {
            if (!this.selectedOPCR) {
                return this.showToast(`Please select ${this.$store.state.data.selectedCampus.isExternal ? 'a WFP' : 'an OPCR'}!`, "error");
            }
            if (target) {
                this.selectedItem = target.planningTargetId;
                this.selectedTarget = this.itemList.find(x => x.id == target.planningTargetId);
            }
            this.selectedAllTarget = target;
            this.onReset();
            this.modalTitle = "Create New Activity Program Initiative";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            if (this.form.isBigProject) {
                this.$v.apiType.$touch();
                if (this.$v.apiType.$invalid) return;
            }
            var data = cloneDeep(this.form);
            data.preOPCRId = this.selectedOPCR.id;
            data.isAdaptation = data.climateAddress === 'Adaptation' ? true : false;
            data.planningApiSectionData = [];
            if (this.form.id > 0) {
                this.$store
                    .dispatch("planningapi/UpdatePlanningApi", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if (this.selectAllAPI) {
                            let index = this.selectedAllTarget.planningApis.findIndex(x => x.id == this.form.id);
                            data.filterKey = `${this.selectedAllTarget.planningTarget} ${data.name}`
                            this.selectedAllTarget.planningApis.splice(index, 1, data);
                        } else {
                            this.targetData.splice(this.indexSelected, 1, data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                data.planningTargetId = this.selectedItem;
                this.$store
                    .dispatch("planningapi/CreatePlanningApi", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.total = 0;
                        res.data.totalResources = this.formatCurrency(0);
                        if (this.selectAllAPI) {
                            res.data.filterKey = `${this.selectedAllTarget.planningTarget} ${res.data.name}`
                            this.selectedAllTarget.planningApis.push(res.data);
                        } else {
                            this.targetData.push(res.data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                description: "",
                schedule: "",
                expectedOutput: "",
                apiTypeId: 0,
                planningTargetId: 0,
                isBigProject: false,
                addressingClimateChange: false,
                climateAddress: 'Adaptation'
            };
            this.apiType = "";
            this.$v.form.$reset();
            this.$v.apiType.$reset();
            // this.$v.previousWork.$reset();
        },
        hideModal() {
            this.$bvModal.hide("modal-standard");
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.form.dateCompleted = new Date(props.item.dateCompleted);
            this.form.climateAddress = props.item.isAdaptation ? 'Adaptation' : 'Mitigation';
            this.indexSelected = this.targetData.indexOf(props.item);
            this.form.apiTypeId = props.item.apiTypeId ?? 0;
            this.apiType = props.item.apiType;
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
            this.modalTitle = "Update Api";
            this.$bvModal.show("modal-standard");
        },
        deleteItem(props) {
            var index = this.targetData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "planningapi/DeletePlanningApi",
                            props.item.id
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            if (res.status == 204) {
                                this.targetData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        updateItemAll({ row, parent }) {
            this.form = cloneDeep(row);
            this.form.planningTargetId = parent.planningTargetId;
            this.form.climateAddress = row.isAdaptation ? 'Adaptation' : 'Mitigation';
            this.form.apiTypeId = parent.apiTypeId ?? 0;
            this.apiType = row.apiType;
            this.selectedAllTarget = parent;
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
            this.modalTitle = "Update Api";
            this.$bvModal.show("modal-standard");
        },
        deleteItemAll({ row, parent }) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("planningapi/DeletePlanningApi", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.planningApis.findIndex(x => x.id == row.id);
                            parent.planningApis.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        postPPMP(row) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.pageLoader(true);
                    const resItem = await this.$store.dispatch(
                        "apiresource/GetAllResourceByAPI",
                        row.id
                    );
                    this.pageLoader(false);
                    if (resItem.data.error) {
                        return this.showToast(
                            resItem.data.errorMessage,
                            "warning"
                        );
                    }
                    if (resItem.data.length == 0) {
                        return this.showToast(
                            "Please add resource before posting",
                            "warning"
                        );
                    }
                    this.$store
                        .dispatch("api/PostApi", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            row.status = "Posted";
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        postWork() {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.pageLoader(true);
                    const resItem = await this.$store.dispatch(
                        "apiresource/GetAllResourceByAPI",
                        this.selectedApiId
                    );
                    this.pageLoader(false);
                    if (resItem.data.error) {
                        return this.showToast(
                            resItem.data.errorMessage,
                            "warning"
                        );
                    }
                    if (resItem.data.length == 0) {
                        return this.showToast(
                            "Please add resource before posting",
                            "warning"
                        );
                    }
                    this.$store
                        .dispatch("api/PostApi", this.selectedApiId)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            this.selectedPPMPStatus = "POSTED";
                            this.targetData[this.apiIndex].status = "Posted";
                            this.showToast("Successfully posted!", "success");
                            this.frontPage = true;
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getApiType() {
            this.$bvModal.show("api-type-modal");
        },
        dropType(data) {
            this.apiType = data.type;
            this.form.apiTypeId = data.id;
        },
        async changeCycle(cycle, created = false) {
            if (!created) {
                this.frontPage = true;
            }
            this.resetSelection();
            this.pageLoader(true);
            await this.getMyOpcrs(cycle, this.$store.state.data.selectedDU.id);
            this.pageLoader(false);
            this.getMyTargets(cycle, this.$store.state.data.selectedDU.id);
            this.loadDepartmentOPCRs = true;
            await this.getDepartmentOPCRs(cycle, this.$store.state.data.selectedDU.id);
            this.loadDepartmentOPCRs = false
        },
        resetSelection() {
            this.selectedOPCR = null;
            this.selectedTarget = null;
            this.selectedItem = 0;
            this.selectAllAPI = false;
            this.targetData = [];
        },
        async getMyOpcrs(cycle, deliveryUnitId) {
            this.opcrs = [];
            this.loadOpcrs = true;
            await this.$store
                .dispatch("preopcr/GetAllPreOpcr", { cycle, deliveryUnitId })
                .then((res) => {
                    if (res.data.error) {
                        this.loadOpcrs = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.opcrs = res.data;
                    if (this.opcrs.length > 0) {
                        this.selectedOPCR = cloneDeep(this.opcrs[0]);
                        this.getAllAPI()
                    }
                })
                .catch(() => {
                    this.showToast("Getting Opcrs Failed", "error");
                });
            this.loadOpcrs = false
        },
        getMyTargets(cycle, deliveryUnitId) {
            this.selectedItem = 0;
            this.targetData = [];
            this.itemList = [];
            this.loadItems = true;
            this.apiName = "";
            this.$store
                .dispatch("planningtarget/GetPostedPlanningTargetByDU", { cycle, deliveryUnitId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.loadItems = false;
                    res.data.sort((a, b) => b.id - a.id);
                    res.data.forEach((item) => {
                        item.searchList = `${item.description} ${item.planningMainTarget.indicatorItem.indicatorItemName}`;
                        item.prexC = item.planningMainTarget.indicatorItem.indicator.prexc.prexcName;
                        item.indicatorItem = item.planningMainTarget.indicatorItem.indicatorItemName;
                        item.classification = item.planningMainTarget.indicatorItem.indicatorItemClassification.classification;
                        item.sort = 3;
                        if (item.planningMainTarget.indicatorItem.indicatorItemClassification.classification.toLowerCase().includes('strategic')) {
                            item.sort = 1;
                        } else if (item.planningMainTarget.indicatorItem.indicatorItemClassification.classification.toLowerCase().includes('core')) {
                            item.sort = 2
                        }
                    });
                    this.itemList = res.data.sort((a, b) => a.sort - b.sort);
                })
                .catch((err) => {
                    this.loadItems = false;
                    this.showToast("Getting Target went wrong!", "error");
                });
        },
        selectIndicatorItem(row) {
            if (this.startTransferAPI) {
                return this.transferApiNow(row);
            }
            this.selectedItem = row.id;
            this.apiName = row.description;
            this.selectedTarget = row;
            this.$refs.opcrDefault.showTarget = false;
            this.selectAllAPI = false;
            this.getAPIbyOPCRandTarget();
        },
        async getAPIbyOPCRandTarget() {
            if (!this.selectedTarget) {
                return;
            }
            this.tableBusy = true;
            this.targetData = [];
            await this.$store
                .dispatch("planningapi/GetPlanningApisByTargetAndOPCR", { preplanningTargetId: this.selectedTarget.id, preOPCRId: this.selectedOPCR.id })
                .then((res) => {
                    if (res.data.error) {
                        this.tableBusy = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        item.showAttachments = false;
                        item.attachmentLoading = false;
                        item.addDocu = false;
                        item.fileSearch = "";
                        item.attachments = [];
                        item.totalResources = this.formatCurrency(item.total);
                        item.selected = false;
                        item.preOPCR = this.opcrs.find(x => x.id == item.preOPCRId)
                    });
                    this.targetData = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.tableBusy = false;
        },
        async goToPPMP(row) {
            this.selectedApi = row;
            this.selectedApiId = row.id;
            this.apiIndex = this.targetData.indexOf(row);
            this.title = "API Resources";
            this.frontPage = false;
            this.scrollToTop();
            this.itemLoading = true;
            this.resourceItems = [];
            await this.$refs['resource-update'].getAllBudgets(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
            await this.getResourceDetails(row.id);
        },
        async goToPPMPAll({ row, parent }) {
            this.selectedAllTarget = parent;
            this.selectedApi = row;
            this.selectedApiId = row.id;
            this.title = "API Resources";
            this.frontPage = false;
            this.scrollToTop();
            this.itemLoading = true;
            this.resourceItems = [];
            await this.$refs['resource-update'].getAllBudgets(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
            await this.getResourceDetails(row.id);
        },
        returnToApi() {
            this.title = `My Pre-planning ${this.$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`;
            this.frontPage = true;
        },
        async updatePackage(id) {
            this.resourceItems = [];
            await this.getResourceDetails(id);
        },
        async getResourceDetails(id) {
            await this.$store
                .dispatch(
                    "planningapiresource/GetPlanningApiResourcesByApi",
                    id
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        let budgetInfo = this.$refs['resource-update'].budgetData.find(
                            (x) => x.id == item.financeTemplateBudgetItemId
                        );
                        item.totalQuantity =
                            item.planningApiResourceDetails.reduce(
                                (pv, cv) => {
                                    return (
                                        parseFloat(pv) + parseFloat(cv.quantity)
                                    );
                                },
                                0
                            );
                        item.financeTemplateBudgetItem = {
                            fundSource: budgetInfo.fundSource,
                            fundClass: budgetInfo.fundClass,
                            accountGroup: budgetInfo.groupName,
                            accountId: budgetInfo.accountGroupId,
                        };
                        item.showRow = true;
                        item.showChild = true;
                        item.filterKey = `${item.itemName}`;
                    });
                    this.resourceItems = res.data;
                    this.itemLoading = false;
                })
                .catch((err) => {
                    this.itemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        addNewItem() {
            this.$refs['resource-update'].addNewItem();
        },
        deleteResourceItem(props) {
            var index = this.resourceItems.indexOf(props);
            var budgetIndex = this.$refs['resource-update'].budgetData.findIndex((x) => x.id == props.financeTemplateBudgetItemId);
            var apiIndex = -1;
            if (this.selectAllAPI) {
                apiIndex = this.selectedAllTarget.planningApis.findIndex(x => x.id == props.planningApiId);
            } else {
                apiIndex = this.targetData.findIndex(x => x.id == props.planningApiId);
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "planningapiresource/DeletePlanningApiResource",
                            props.id
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            if (res.status == 204) {
                                this.resourceItems.splice(index, 1);
                                this.$refs['resource-update'].budgetData[budgetIndex].balance += props.total;
                                this.$refs['resource-update'].budgetData[budgetIndex].total -= props.total;
                                this.$refs['resource-update'].budgetData[budgetIndex].resourceCount--;
                                if (this.selectAllAPI) {
                                    this.selectedAllTarget.planningApis[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                                } else {
                                    this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                                }
                                this.showToast("Successfully deleted!", "success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        async updateResourceItem({ props, type }) {
            this.pageLoader(true);
            this.$refs['resource-update'].getItemInfo(props, type);
            this.pageLoader(false);
        },
        getWork() {
            this.$refs.backlog.getData();
            this.$bvModal.show("backlog-modal");
        },
        dropWork(data) {
            this.previousWork = cloneDeep(data);
            this.form.apiId = data.id;
        },
        uploadedDocument({ response, id }) {
            let index = this.targetData.findIndex((item) => item.id == id);
            this.targetData[index].attachments.push(response);
        },
        searchDocu(row) {
            let data = row.attachments;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        async printOPCR(type = 2) {
            if (type == 1) {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/OPCR",
                    routeVariables: [this.selectedOPCR.id],
                });
            } else if (type == 3) {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/OPCR/V3",
                    routeVariables: [this.selectedOPCR.id],
                });
            } else if (type == 4) {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/OPCR/V4",
                    routeVariables: [this.selectedOPCR.id],
                });
            } else {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/OPCR/V2",
                    routeVariables: [this.selectedOPCR.id],
                });
            }
            this.$bvModal.show("print-options-modal");
        },
        async printDULIB() {
            if (this.$store.state.data.selectedCampus.isExternal) {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/LIB/WFP",
                    routeVariables: [this.selectedOPCR.id],
                });
            } else {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/LIB",
                    routeVariables: [this.selectedOPCR.id],
                });
            }
            this.$bvModal.show("print-options-modal");
        },
        transferApiIfs(row) {
            if (this.selectedTransfer.planningApiId == row.id || row.departmentPlanningApiId) {
                return false;
            }
            return true;
        },
        transferItem(arr) {
            this.selectedTransfer = cloneDeep(arr[0]);
            this.frontPage = true;
        },
        cancelTransfer() {
            this.frontPage = true;
            this.selectedTransfer = {};
        },
        selectTransferApi({ row, parent }) {
            let data = {
                id: this.selectedTransfer.id,
                planningApiId: row.id,
            }
            this.$store
                .dispatch("planningapiresource/MovePlanningApiResource", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.total += this.selectedTransfer.total;
                    row.totalResources = this.formatCurrency(row.total);
                    if (parent) {
                        let index = parent.planningApis.findIndex((e) => e.id === this.selectedTransfer.planningApiId);
                        if (index > -1) {
                            parent.planningApis[index].total -= this.selectedTransfer.total;
                            parent.planningApis[index].totalResources = this.formatCurrency(parent.planningApis[index].total);
                        }
                    } else {
                        let index = this.targetData.findIndex((e) => e.id === this.selectedTransfer.planningApiId);
                        if (index > -1) {
                            this.targetData[index].total -= this.selectedTransfer.total;
                            this.targetData[index].totalResources = this.formatCurrency(this.targetData[index].total);
                        }
                    }
                    this.cancelTransfer();
                    this.showToast("Successfully transferred!", "success");
                })
                .catch((err) => {
                    this.showToast("Cannot transfer!", "error");
                });
        },
        async changeDU(du) {
            this.title = du.isExternal ? "My Planning WFP" : "My Planning OPCR",
                this.items = [
                    {
                        text: "Dashboards",
                        href: "/",
                    },
                    {
                        text: du.isExternal ? "My Planning WFPs" : "My Planning OPCRs",
                        active: true,
                    },
                ],
                this.frontPage = true;
            this.resetSelection();
            this.pageLoader(true);
            await this.getMyOpcrs(this.$store.state.data.cycle, du.id);
            this.pageLoader(false);
            this.getMyTargets(this.$store.state.data.cycle, du.id);
            this.getDepartmentOPCRs(this.$store.state.data.cycle, du.id);
            this.selectAllAPI = false;
        },
        async printWFP() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/WFP",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        startDrag(e, item) {
            e.dataTransfer.dropEffect = 'move';
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('itemID', item.id);
        },
        onDropZone(e, item) {
            if (this.moveApi.planningTargetId == item.id) {
                this.showToast('Cannot transfer to the same target', 'error');
                return;
            }
            Swal.fire({
                title: 'Are you sure?',
                text: "You want to transfer this api to this target?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, transfer it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    let data = {
                        id: cloneDeep(this.moveApi.id),
                        name: cloneDeep(this.moveApi.name),
                        description: cloneDeep(this.moveApi.description),
                        apiTypeId: cloneDeep(this.moveApi.apiTypeId),
                        planningTargetId: cloneDeep(item.id),
                    }
                    this.$store
                        .dispatch("planningapi/UpdatePlanningApi", data)
                        .then((res) => {
                            let index = this.targetData.findIndex(x => x.id == this.moveApi.id);
                            this.targetData.splice(index, 1);
                            this.showToast("Successfully transferred!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            })
        },
        printPPMPByApi({ id, type }) {
            this.$refs.printOpt.putOptions({
                apiUrl: type == 2 ? "api/Report/Procurement/Planning/PPMP/Api/Report" : "api/Report/PrePlanning/PPMP/API",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printIndicativePR(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/PR",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        handleMouseDown(e, item) {
            this.moveApi = item;
            e.target.style.cursor = 'grabbing';
            e.target.parentNode.parentNode.parentNode.setAttribute('draggable', 'true');
        },
        handleMouseUp(e) {
            e.target.style.cursor = 'grab';
            e.target.parentNode.parentNode.parentNode.setAttribute('draggable', 'false');
        },
        onResetOPCR() {
            this.opcr = {
                id: 0,
                title: '',
                deliveryUnitId: this.$store.state.data.selectedDU.id,
                cycle: this.$store.state.data.cycle,
                isSupplemental: false,
            }
        },
        createNewOPCR() {
            this.onResetOPCR();
            this.$refs.opcrDefault.showOPCR = false;
            this.modalTitle = `Create New ${this.$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`;
            this.$bvModal.show('opcr-modal');
        },
        onSubmitOPCR() {
            this.submitted = true;
            this.$v.opcr.$touch();
            if (this.$v.opcr.$invalid) {
                return;
            }
            let data = cloneDeep(this.opcr);
            if (data.id == 0) {
                this.$store.dispatch("preopcr/AddPreOpcr", data)
                    .then((res) => {
                        this.opcrs.push(res.data);
                        this.showToast("Successfully created!", "success");
                        this.$bvModal.hide('opcr-modal');
                        this.$refs.opcrDefault.showOPCR = true;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store.dispatch("preopcr/UpdatePreOpcr", data)
                    .then((res) => {
                        let index = this.opcrs.findIndex(x => x.id == data.id);
                        this.opcrs.splice(index, 1, data);
                        if (this.selectedOPCR.id == data.id) {
                            this.selectedOPCR = cloneDeep(data);
                        }
                        this.showToast("Successfully updated!", "success");
                        this.$bvModal.hide('opcr-modal');
                        this.$refs.opcrDefault.showOPCR = true;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        selectOPCR(opcr) {
            if (this.startTranferApiToOPCR) {
                if (this.selectedOPCR.id == opcr.id) {
                    this.showToast('Cannot transfer to the same OPCR', 'error');
                    return;
                }
                this.transferToSelectedOPCR(opcr.id);
            } else {
                this.selectedOPCR = cloneDeep(opcr);
                this.$refs.opcrDefault.showOPCR = false;
                if (this.selectAllAPI) {
                    this.getAllAPI();
                } else {
                    this.getAPIbyOPCRandTarget();
                }
            }
        },
        transferToSelectedOPCR(id) {
            let data = {
                preOPCRId: id,
                planningApiIds: [],
            }
            this.targetData.map(x => {
                x.planningApis.map(y => {
                    if (y.selected) {
                        data.planningApiIds.push(y.id);
                    }
                })
            })
            Swal.fire({
                title: "Are you sure?",
                text: "You want to transfer this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, transfer it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("preopcr/AddPreOpcrItems", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            data.planningApiIds.map(x => {
                                let index = this.targetData.findIndex(y => y.id == x);
                                this.targetData.splice(index, 1);
                            });
                            this.startTranferApiToOPCR = false;
                            this.openSelectionOfApi();
                            this.$refs.opcrDefault.showOPCR = false;
                            this.showToast("Successfully transferred!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        updateOPCR(opcr) {
            this.opcr = cloneDeep(opcr);
            this.$refs.opcrDefault.showOPCR = false;
            this.modalTitle = `Update ${this.$store.state.data.selectedCampus.isExternal ? 'WFP' : 'OPCR'}`;
            this.$bvModal.show('opcr-modal');
        },
        deleteOPCR(opcr) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to delete this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch("preopcr/DeletePreOpcr", opcr.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.opcrs.findIndex(x => x.id == opcr.id);
                            this.opcrs.splice(index, 1);
                            if (opcr.id == (this.selectedOPCR && this.selectedOPCR.id)) {
                                this.selectedOPCR = null;
                                this.$refs.opcrDefault.showOPCR = true;
                            }
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        openSelectionOfApi() {
            this.startSelection = !this.startSelection;
            this.selectedApiActions = '';
            if (this.startSelection) {
                this.targetData.map(x => {
                    x.selected = false;
                })
            }
        },
        transferApiToOPCR() {
            this.startTranferApiToOPCR = true;
            this.$refs.opcrDefault.showOPCR = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    let element = document.getElementById('opcrRef').getBoundingClientRect();
                    this.directionElement = element;
                }, 100);
            });
        },
        async transferApiNow(row) {
            if (row.id == this.targetData[0].planningTargetId) {
                return this.showToast("Cannot transfer!", "warning");
            }
            for await (const x of this.targetData) {
                if (x.selected) {
                    let data = { ...x };
                    data.planningTargetId = row.id;
                    await this.$store
                        .dispatch("planningapi/UpdatePlanningApi", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.targetData.findIndex(x => x.id == data.id);
                            this.targetData.splice(index, 1);
                            this.startTransferAPI = false;
                            this.$refs.opcrDefault.showTarget = false;
                            this.startSelection = false;
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            }
        },
        transferApiToKPI() {
            this.startTransferAPI = true;
            this.$refs.opcrDefault.showTarget = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    let element = document.getElementById('targetRef').getBoundingClientRect();
                    this.directionElement = element;
                }, 100);
            });
        },
        postOPCR(opcr) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("preopcr/PostPreOpcr", opcr.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            opcr.status = 'POSTED';
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async getAllAPI() {
            this.selectAllAPI = true;
            this.targetData = [];
            this.tableBusy = true;
            this.selectedTarget = null;
            this.$refs.opcrDefault.showTarget = false;
            this.apiName = 'All';
            this.selectedItem = 0;
            if (!this.selectedOPCR) {
                return this.tableBusy = false;
            }
            await this.$store
                .dispatch("planningapi/GetAllPlanningApis", this.selectedOPCR.id)
                // .dispatch("planningapi/GetPlanningApisByOPCR", this.selectedOPCR.id)
                .then((res) => {
                    if (res.data.error) {
                        this.tableBusy = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.sort = 3;
                        if (x.type.toLowerCase().includes('strategic')) {
                            x.sort = 1;
                        } else if (x.type.toLowerCase().includes('core')) {
                            x.sort = 2
                        }
                        x.showApis = x.planningApis.length;
                        x.filterKey = `${x.planningTarget}`;
                        x.planningApis.map(item => {
                            item.showAttachments = false;
                            item.attachmentLoading = false;
                            item.addDocu = false;
                            item.fileSearch = "";
                            item.attachments = [];
                            item.totalResources = this.formatCurrency(item.total);
                            item.selected = false;
                            x.filterKey += ` ${item.name}`;
                            item.filterKey = `${x.planningTarget} ${item.name}`;
                        }).sort((a, b) => a.name.localeCompare(b.name))
                    });
                    this.targetData = res.data.sort((a, b) => a.planningTarget.localeCompare(b.planningTarget)).sort((a, b) => a.sort - b.sort);
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.tableBusy = false;
        },
        closeTargetPopOver() {
            this.startTransferAPI = false;
        },
        async printPPMP(type) {
            if (type == 2) {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/Planning/PPMP/Report",
                    routeVariables: [this.selectedOPCR.id],
                });
            } else {
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/PrePlanning/PPMP/OPCR",
                    routeVariables: [this.selectedOPCR.id],
                });
            }
            this.$bvModal.show("print-options-modal");
        },
        closeOPCRPopover() {
            this.startTranferApiToOPCR = false;
        },
        closeUpdateModal(data) {
            let index = this.resourceItems.findIndex(x => x.id == data.id);
            this.resourceItems[index].totalQuantity = data.quantity;
            this.resourceItems[index].totalWithInflation = data.amount;
        },
        successUpdateResource(data) {
            let index = this.resourceItems.findIndex(x => x.id == data.id);
            this.resourceItems.splice(index, 1, data);
        },
        successAddResource(data) {
            this.resourceItems.push(data);
        },
        updateItemColumn(data) {
            if (data.type === 'deduct') {
                this.resourceItems.find((e) => e.id == data.id)[data.column] -= data.value;
            } else if (data.type === 'add') {
                this.resourceItems.find((e) => e.id == data.id)[data.column] += data.value;
            } else {
                this.resourceItems.find((e) => e.id == data.id)[data.column] = data.value;
            }
        },
        updateTotals(data) {
            if (this.selectAllAPI) {
                let apiIndex = this.selectedAllTarget.planningApis.findIndex((e) => e.id == data.apiId)
                this.selectedAllTarget.planningApis[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                this.selectedAllTarget.planningApis[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
            } else {
                let apiIndex = this.targetData.findIndex((e) => e.id === data.apiId);
                this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
            }
        },
        postApis(items, type) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    let err = 0;
                    for await (const x of items) {
                        if (x.status.toUpperCase().includes('DRAFT') || x.status.toUpperCase().includes('RETURN')) {
                            await this.$store
                                .dispatch("planningapi/PostPlanning", x.id)
                                .then((res) => {
                                    if (res.data.error) {
                                        err++;
                                    } else {
                                        x.status = 'POSTED';
                                    }
                                })
                        }
                    }
                    if (err > 0) {
                        this.showToast("Something went wrong!", "error");
                    } else {
                        if (type === 'multiple') {
                            this.openSelectionOfApi();
                        }
                        this.showToast("Successfully posted!", "success");
                    }
                }
            });
        },
        viewOPCRLogs(id) {
            this.$bvModal.show('opcr-logs-modal');
            this.$refs.opcrLogs.modalTitle = `${this.selectedOPCR.title} Logs`
            this.$refs.opcrLogs.getData(this.selectedOPCR);
        },
        showCart() {
            this.$bvModal.show('cart-items-modal');
        },
        selectCartItem(item) {
            let dataItem = cloneDeep(item.item);
            dataItem.cartItemId = item.id;
            this.$refs['resource-update'].dropItem(dataItem, true);
            this.$bvModal.hide('cart-items-modal');
        },
        selectApprovedItem(item) {
            let dataItem = cloneDeep(item);
            this.$refs['resource-update'].dropItem(dataItem, false);
            this.$bvModal.hide('cart-items-modal');
        },
        async getApprovedRequest() {
            this.approveLoading = true;
            await this.$store
                .dispatch("itemrequest/GetDUApprovedItemRequest", {
                    deliveryUnitId: this.$store.state.data.selectedDU.id,
                    cycle: this.$store.state.data.cycle
                })
                .then((res) => {
                    this.approveLoading = false;
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    res.data.forEach((item) => {
                        item.filterKey = `${item.itemName} ${item.description}`;
                    });
                    this.approved = res.data;
                })
                .catch((err) => {
                    this.approveLoading = false;
                    this.showToast(
                        "Something went wrong! - getting approved item request",
                        "error"
                    );
                });
            this.approveLoading = false;
        },
        removeFromCart(id) {
            this.$store
                .dispatch("deliveryunititemcart/DeleteDeliveryUnitItemCart", id)
                .then((res) => {
                    if (res.data.error) {
                        return;
                    }
                    let index = this.carts.findIndex(x => x.id == id);
                    this.carts.splice(index, 1);
                })
                .catch((err) => {
                    return;
                });
        },
        async getDepartmentOPCRs(cycle, deliveryUnitId) {
            this.departmentOPCRs = [];
            await this.$store
                .dispatch("departmentpreopcr/GetAllPostedOPCR", { cycle, deliveryUnitId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.viewApi = false;
                        item.apis = [];
                        item.apiLoading = false;
                    })
                    let grpData = [];
                    let grpDep = groupBy(res.data, 'departmentId');
                    for (const [key, value] of Object.entries(grpDep)) {
                        grpData.push({
                            id: value[0].department.id,
                            department: value[0].department,
                            opcrs: value,
                            selectionOfAPI: false,
                            selectAllAPI: false,
                            searchAPI: '',
                        })
                    }
                    this.departmentOPCRs = grpData;
                })
                .catch(() => {
                    this.showToast("Getting Department Opcrs Failed", "error");
                });
        },
        showImportApis() {
            this.departmentOPCRs.map(x => {
                x.opcrs.map(y => {
                    y.viewApi = false;
                })
            })
            this.$bvModal.show('import-apis-modal');
        },
        async viewApis(row) {
            row.viewApi = !row.viewApi;
            if (row.viewApi) {
                row.apiLoading = true;
                await this.getDepartmentApis(row);
                row.apiLoading = false;
            }
        },
        async getDepartmentApis(row) {
            await this.$store
                .dispatch("departmentplanningapi/GetAllDepartmentPlanningApi", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.apis = [];
                    res.data.map(item => {
                        if (item.planningApis.length) {
                            item.filterKey = `${item.planningTarget}`;
                            item.selectAllAPI = false;
                            item.planningApis.map(x => {
                                x.selected = false;
                                x.filterKey = `${x.name} ${item.planningTarget}`;
                                item.filterKey += ` ${x.name}`;
                            })
                            row.apis.push(item);
                        }
                    })
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        importApi(items) {
            let ids = [];
            items.map(x => {
                ids.push({ id: x.id });
            })
            Swal.fire({
                title: "Are you sure?",
                text: `You want to import this ${items.length} ${items.length > 1 ? 'apis' : 'api'}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, import it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("departmentplanningapi/ImportDepartmentPlanningApi", {
                            ids: ids,
                            opcrId: this.selectedOPCR.id,
                        })
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            items.map(x => {
                                x.selected = false;
                                x.imported = true;
                            })
                            this.showToast("Successfully imported!", "success");
                            this.getAllAPI()
                            this.$bvModal.hide('import-apis-modal');
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        returnOPCR(opcr) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to return this? This will remove all imported API's from this OPCR",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, return it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("departmentpreopcr/ReturnDepartmentOPCR", opcr.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.departmentOPCRs.findIndex(x => x.id == opcr.id);
                            this.departmentOPCRs.splice(index, 1);
                            this.getAllAPI();
                            this.showToast("Successfully returned!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            })
        },
        filterImportApi(apis, search) {
            let data = apis;
            if (search && search.trim !== '') {
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(search.toUpperCase());
                })
            }
            return data;
        },
        filterImportTarget(targets, search) {
            let data = targets;
            if (search && search.trim !== '') {
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(search.toUpperCase());
                })
            }
            return data;
        },
        checkIfWantToImport({ apis }) {
            let count = 0;
            apis.map(item => {
                item.planningApis.map(x => {
                    if (x.selected) {
                        count++;
                    }
                });
            });
            return count > 0 ? true : false;
        },
        importApis({ apis }) {
            let data = [];
            apis.map(item => {
                item.planningApis.map(x => {
                    if (x.selected) {
                        data.push(x);
                    }
                });
            });
            this.importApi(data);
        },
        selectAll(event, row) {
            row.planningApis.map(item => {
                if (!item.imported) {
                    item.selected = event.target.checked;
                }
            });
        },
        checkApi(row) {
            let checked = row.planningApis.filter(x => x.selected);
            let notImported = row.planningApis.filter(x => !x.imported);
            return row.selectAllAPI = checked.length == notImported.length ? true : false;
        },
        checkIfImportedApis(apis) {
            let imported = apis.filter(x => x.imported);
            return imported.length != apis.length ? true : false;
        },
        changeIsBigProject() {
            this.apiType = "";
            this.form.apiTypeId = 0;
            this.form.apiType = null;
        },
        async showApiAttachments(api) {
            this.$bvModal.show("upload-attachment-modal");
            this.$refs.attachmentModal.setUploadOpt({
                type: "API Special Projects",
                placement: "left",
                folder: "Office",
            });
            await this.$refs.attachmentModal.getData(api.id);
        },
        deleteAllItems() {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete all items!",
            }).then(async (result) => {
                if (result.value) {
                    let errors = 0;
                    for await (const item of this.resourceItems) {
                        await this.$store
                            .dispatch("planningapiresource/DeletePlanningApiResource", item.id)
                            .then((res) => {
                                if (res.data.error) {
                                    errors++;
                                    return;
                                }
                            })
                            .catch((err) => {
                                errors++;
                                return;
                            });
                    }
                    if (errors > 0) {
                        this.showToast("Some items cannot be deleted!", "error");
                    } else {
                        this.resourceItems = [];
                        this.showToast("All items successfully deleted!", "success");
                    }
                }
            });
        },
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU">
        <PageHeader :title="title" :items="items" />
        <b-modal id="opcr-modal" :title="modalTitle" size="md" hide-footer no-close-on-backdrop no-close-on-esc>
            <form @submit.prevent="onSubmitOPCR">
                <div class="mb-3">
                    <label class="form-label">Title</label>
                    <input type="text" class="form-control" v-model="opcr.title" />
                </div>
                <div class="
                        form-check
                        form-checkbox-outline
                        form-check-success
                        mb-3
                    ">
                    <input type="checkbox" :id="`isSupplemental`" checked="checked" class="
                            form-check-input
                        " v-model="opcr.isSupplemental
                            " /><label :for="`isSupplemental`" class="
                            form-check-label
                        ">
                        <h5 class="
                                text-dark
                                mb-0
                            ">
                            Supplemental
                        </h5>
                    </label>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="
                            btn btn-primary
                        ">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('opcr-modal')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="modal-standard" :title="modalTitle" size="md" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="onCreate" class="needs-validation" ref="apiForm">
                <p v-if="selectedAllTarget">Target: <span class="text-yellow">{{ selectedAllTarget.planningTarget
                        }}</span></p>
                <b-row>
                    <div class="mb-3">
                        <label for="name">Activity Program Initiative</label>
                        <textarea id="name" rows="5" v-model="form.name"
                            placeholder="Enter Activity Program Initiative..." class="form-control"
                            :class="{ 'is-invalid': submitted && $v.form.name.$error }"></textarea>
                        <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
                            <span v-if="!$v.form.name.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="description">Expected Output
                        </label>
                        <textarea autocomplete="off" id="name" rows="3" v-model="form.expectedOutput"
                            placeholder="Enter Expected Output..." class="form-control"></textarea>
                    </div>
                    <div class="mb-3">
                        <label for="description">Others Involved (Optional)
                        </label>
                        <textarea autocomplete="off" id="name" rows="3" v-model="form.description"
                            placeholder="Enter Others Involved..." class="form-control"></textarea>
                    </div>
                    <div class="mb-3" v-if="$store.state.data.selectedCampus.isExternal">
                        <label for="description">Schedule
                        </label>
                        <textarea autocomplete="off" id="name" rows="3" v-model="form.schedule"
                            placeholder="Enter Schedule..." class="form-control"></textarea>
                    </div>
                    <div class="mb-2">
                        <div class="form-check form-checkbox-outline form-check-success mb-0">
                            <input type="checkbox" id="isBigProject" class="form-check-input"
                                v-model="form.isBigProject" @change="changeIsBigProject" />
                            <label for="isBigProject" class="form-check-label">Special Project</label>
                        </div>
                    </div>
                    <div class="mb-3" v-if="form.isBigProject">
                        <label for="apiTypeId">API Type</label>
                        <b-input-group>
                            <template #append>
                                <b-button @click="getApiType" variant="outline-info">
                                    <i class="mdi mdi-clipboard-text-search-outline"></i>
                                </b-button>
                            </template>
                            <input autocomplete="off" type="text" disabled placeholder="Search API Type..."
                                class="form-control" :class="{ 'is-invalid': submitted && $v.apiType.$error }"
                                v-model="apiType" />
                        </b-input-group>
                        <div v-if="submitted && $v.apiType.$error" class="invalid-feedback">
                            <span v-if="!$v.apiType.required">This value is required.</span>
                        </div>
                    </div>
                </b-row>
                <div class="d-flex mb-2">
                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                        <input type="checkbox" id="addressClimateChange" class="form-check-input"
                            v-model="form.addressingClimateChange" />
                        <label for="addressClimateChange" class="form-check-label">Addressing Climate Change</label>
                    </div>
                </div>
                <div class="mb-2 ms-3" v-if="form.addressingClimateChange">
                    <b-form-radio-group v-model="form.climateAddress" :options="climateAddreses" name="status-options"
                        plain>
                    </b-form-radio-group>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="hideModal">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="import-apis-modal" title="Department APIs" size="xl" hide-footer no-close-on-backdrop
            no-close-on-esc>
            <div class="d-flex justify-content-between mb-3">
                <div>
                    <input type="text" class="form-control" placeholder="Search OPCR">
                </div>
            </div>
            <template v-if="loadDepartmentOPCRs">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="spinner-grow text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div v-if="departmentOPCRs.length">
                    <ul class="px-4 py-0">
                        <li v-for="x in departmentOPCRs" :key="x.id">
                            <h5 class="text-warning">{{ x.department.departmentName }}</h5>
                            <template v-for="y in x.opcrs">
                                <div class="ms-3" :key="`${x.id}${y.id}`">
                                    <b-card no-body class="shadow-none position-relative mb-0">
                                        <b-card-header class="border" header-tag="header" role="tab">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h5 class="mb-0">{{ y.title }}</h5>
                                                <button type="button" class="btn btn-sm btn-warning" title="Return DPCR"
                                                    @click="returnOPCR(y)"><i class="bx bx-arrow-back"></i>Return
                                                    DPCR</button>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="viewApis(y)">{{ y.viewApi ? 'Hide'
                                                    :
                                                    'View' }} Api's</a>
                                            </div>
                                        </b-card-header>
                                        <b-collapse :visible="y.viewApi" :accordion="`detail-accordion-${y.id}`"
                                            role="tabpanel">
                                            <b-card-body class="border">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <div>
                                                        <h5 class="mb-0">List of API's</h5>
                                                    </div>
                                                    <div class="d-flex gap-2">
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Search API" v-model="x.searchAPI">
                                                        <button class="btn btn-primary" type="button"
                                                            title="Import Selected API" v-if="checkIfWantToImport(y)"
                                                            @click="importApis(y)"><i
                                                                class="bx bx-download"></i></button>
                                                    </div>
                                                </div>
                                                <template v-if="y.apiLoading">
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <div class="spinner-grow text-primary" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="!y.apis.length">
                                                        <h6>No data found...</h6>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="w in filterImportTarget(y.apis, x.searchAPI)">
                                                            <div :key="`${x.id}${y.id}${w.planningTargetId}`">
                                                                <div class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                        mb-0
                                                                    " v-if="checkIfImportedApis(w.planningApis)">
                                                                    <input type="checkbox"
                                                                        :id="`sa-${x.id}-${y.id}-${y.planningTargetId}`"
                                                                        class="form-check-input"
                                                                        @change="selectAll($event, w)"
                                                                        v-model="w.selectAllAPI" />
                                                                    <label
                                                                        :for="`sa-${x.id}-${y.id}-${y.planningTargetId}`"
                                                                        class="form-check-label">
                                                                        <h5 class="text-yellow">{{ w.planningTarget }}
                                                                        </h5>
                                                                    </label>
                                                                </div>
                                                                <h5 class="text-yellow" v-else>{{ w.planningTarget }}
                                                                </h5>
                                                                <template
                                                                    v-for="z in filterImportApi(w.planningApis, x.searchAPI)">
                                                                    <b-card-header class="border position-relative"
                                                                        header-tag="header" role="tab"
                                                                        :key="`${x.id}${y.id}${w.planningTargetId}${z.id}`">
                                                                        <div
                                                                            class="d-flex justify-content-between align-items-center">
                                                                            <div>
                                                                                <template v-if="!z.imported">
                                                                                    <div class="
                                                                                            form-check
                                                                                            form-checkbox-outline
                                                                                            form-check-success
                                                                                            mb-0
                                                                                        ">
                                                                                        <input type="checkbox"
                                                                                            :id="`cb-${x.id}-${y.id}-${z.id}`"
                                                                                            checked="checked"
                                                                                            class="form-check-input"
                                                                                            v-model="z.selected"
                                                                                            @change="checkApi(w)" /><label
                                                                                            :for="`cb-${x.id}-${y.id}-${z.id}`"
                                                                                            class="form-check-label">
                                                                                            <p class="mb-0 fs-5">
                                                                                                {{ z.name }}</p>
                                                                                            <small class="d-block"
                                                                                                v-if="z.description">[{{
                                                                                                    z.description
                                                                                                }}]</small>
                                                                                        </label>
                                                                                    </div>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <p class="mb-0 fs-5">{{ z.name }}
                                                                                    </p>
                                                                                    <small class="d-block"
                                                                                        v-if="z.description">[{{
                                                                                            z.description }}]</small>
                                                                                </template>
                                                                                <div>Total: {{ formatCurrency(z.total)
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                            <template v-if="!z.imported">
                                                                                <div v-if="!checkIfWantToImport(y)">
                                                                                    <button type="button"
                                                                                        class="btn btn-sm btn-primary"
                                                                                        title="Import API"
                                                                                        @click="importApi([z])"><i
                                                                                            class="bx bx-download"></i></button>
                                                                                </div>
                                                                            </template>
                                                                            <template v-else>
                                                                                <span>Imported</span>
                                                                            </template>
                                                                        </div>
                                                                    </b-card-header>
                                                                </template>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </template>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                            </template>
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <h4>No data found...</h4>
                </div>
            </template>
        </b-modal>
        <ResourceUpdate ref="resource-update" :updatableMixOption="false" :selectedTransfer="selectedTransfer"
            :selectedApiId="selectedApiId" :selectTransferBudget="true" :carts="carts" @close-update="closeUpdateModal"
            @update-item="successUpdateResource" @add-item="successAddResource" @specific-item-update="updateItemColumn"
            @update-package="updatePackage" @update-totals="updateTotals" @refresh-all="goToPPMP(selectedApi)"
            @view-cart="showCart" @remove-from-cart="removeFromCart" />
        <div class="row position-relative">
            <div class="col-12">
                <transition name="slide-fade">
                    <div v-if="frontPage">
                        <OPCRView ref="opcrDefault" opcrType="planning" :department="false" :apiName="apiName"
                            :selectedItem="selectedItem" :selectedTransfer="selectedTransfer"
                            :selectedOPCR="selectedOPCR" :selectAllAPI="selectAllAPI" :selectedTarget="selectedTarget"
                            :opcrs="opcrs" :targetData="targetData" :itemList="itemList" :tableBusy="tableBusy"
                            :startSelection="startSelection" :loadItems="loadItems" @createNewOPCR="createNewOPCR"
                            @getAllAPI="getAllAPI" @closeOPCRPopover="closeOPCRPopover" @selectOPCR="selectOPCR"
                            @viewOPCRLogs="viewOPCRLogs" @closeTargetPopOver="closeTargetPopOver"
                            @selectIndicatorItem="selectIndicatorItem" @openSelectionOfApi="openSelectionOfApi"
                            @selectTransferApi="selectTransferApi" @goToPPMP="goToPPMP" @goToPPMPAll="goToPPMPAll"
                            @postOPCR="postOPCR" @addApi="addApi" @deleteItem="deleteItem"
                            @deleteItemAll="deleteItemAll" @updateItemAll="updateItemAll" @updateItem="updateItem"
                            @deleteOPCR="deleteOPCR" @updateOPCR="updateOPCR" @transferApiToOPCR="transferApiToOPCR"
                            @transferApiToKPI="transferApiToKPI" @showImportApis="showImportApis"
                            @showApiAttachments="showApiAttachments" @printDULIB="printDULIB" @printPPMP="printPPMP"
                            @printPPMPByApi="printPPMPByApi" @printWFP="printWFP" @printOPCR="printOPCR"
                            @printIndicativePR="printIndicativePR" />
                    </div>
                    <div v-else>
                        <ItemsView :loading="itemLoading" :planning="true" :department="false"
                            :selectedApi="selectedApi" :selectedOPCR="selectedOPCR" :tableData="resourceItems"
                            @returnToApi="returnToApi" @addItem="addNewItem" @updateItem="updateResourceItem"
                            @transferItem="transferItem" @deleteItem="deleteResourceItem"
                            @generateIndicativePR="printIndicativePR" @deleteAllItems="deleteAllItems" />
                    </div>
                </transition>
            </div>
        </div>
        <div v-if="startTransferAPI || startTranferApiToOPCR" class="position-fixed"
            style="inset:0;background-color:rgba(0, 0, 0, 0.8);z-index:100;">
            <div v-if="directionElement" class="position-fixed font-size-18"
                :style="{ 'top': `${directionElement.top + (directionElement.height / 2)}px`, 'left': `${directionElement.right + 10}px` }">
                <i class="fas fa-hand-point-left pointing-animation me-3"></i>{{ startTranferApiToOPCR ?
                    'Select OPCR from the list' : 'Select KPI from the list' }}
            </div>
        </div>
        <api-type @dropData="dropType($event)"></api-type>
        <back-log-modal ref="backlog" @dropData="dropWork($event)"></back-log-modal>
        <print-options ref="printOpt"></print-options>
        <div v-if="selectedTransfer.id">
            <div class="position-fixed p-4" style="top: 125px;left:50%;transform:translateX(-50%);">
                <div>
                    <span class="bg-success badge p-2 font-size-14">Transfer Item:
                        <u>{{ selectedTransfer.itemName }}</u>
                    </span>
                    <div class="text-center">
                        <small>Select API & Budget Item to Proceed</small>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-warning position-fixed" style="bottom: 2%; right: 3%"
                @click="cancelTransfer">
                <i class="bx bx-x me-1"></i>Cancel Transfer Items
            </button>
        </div>
        <opcr-logs ref="opcrLogs"></opcr-logs>
        <b-modal id="cart-items-modal" title="Items" size="lg" title-class="font-18" hide-footer no-close-on-backdrop>
            <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
                <b-tab title="Cart Items" active>
                    <CartItems :items="carts" :withActions="false" @select-item="selectCartItem" />
                </b-tab>
                <b-tab title="Approved Request Items" @click="getApprovedRequest">
                    <RequestItems :items="approved" :busy="approveLoading" :selectable="true" :withActions="false"
                        @select-item="selectApprovedItem" />
                </b-tab>
            </b-tabs>
        </b-modal>
        <attachment-modal :wActions="true" title="Special Project Attachments" ref="attachmentModal"></attachment-modal>
    </Layout>
</template>
